<template>
    <div class="home-pic-rows-root">
        <HomePic v-for="(item) in $config.HomePics" :key="item.name" :image="item.pic" :fillColor="item.fillColor"></HomePic>
    </div>
</template>
<script>
    import HomePic from '@/components/HomePic';
    export default {
        components: {
            HomePic
        },
        data() {
            return {};
        }
    }
</script>
<style scoped>
    .home-pic-rows-root{
        width: 100%;
        height: 100%;
    }
</style>
